<button mat-ripple class="sidebar-create-sr-button btn-light flex-center" [routerLink]="['/v2/create-service-request/step1']">
    <mat-icon>add</mat-icon>
    <span>Service Request</span>
</button>
